module.exports = __webpack_public_path__ + "assets/img/2468.5ca39127.png";